<app-navbar (pixelHeightChanged)="setTopMarginForNavbar($event)"></app-navbar>

<div class="container mt-4" [style]="'padding-top: ' + topMargin + 'px;'">
  <wm-contractor-registration-details
    [registrationId]="registrationId"
  ></wm-contractor-registration-details>
</div>
